<template>
  <div id="root">
    <div :class="cssClasses">
      <router-view
        name="layout"
        :is-x-small="screen.isXSmall"
        :is-large="screen.isLarge"
      >
        <div class="content">
          <router-view name="content" />
        </div>
      </router-view>
    </div>
  </div>
</template>

<script>
import { locale } from 'devextreme/localization'
import { config } from './config'
import { sizes, subscribe, unsubscribe } from './utils/media-query'

function getScreenSizeInfo() {
  const screenSizes = sizes()

  return {
    isXSmall: screenSizes['screen-x-small'],
    isLarge: screenSizes['screen-large'],
    cssClasses: Object.keys(screenSizes).filter((cl) => screenSizes[cl]),
  }
}

export default {
  name: 'App',
  data() {
    return {
      title: config.title,
      screen: getScreenSizeInfo(),
    }
  },
  computed: {
    cssClasses() {
      return ['app'].concat(this.screen.cssClasses)
    },
  },
  created() {
    locale(config.locale)
  },
  mounted() {
    subscribe(this.screenSizeChanged)
  },
  beforeDestroy() {
    unsubscribe(this.screenSizeChanged)
  },
  methods: {
    screenSizeChanged() {
      this.screen = getScreenSizeInfo()
    },
  },
}
</script>

<style lang="scss">
html,
body {
  margin: 0;
  min-height: 100%;
  height: 100%;
}

#root {
  height: 100%;
}

* {
  box-sizing: border-box;
}

.app {
  background-color: darken(#fff, 5);
  display: flex;
  height: 100%;
  width: 100%;
}
</style>
